import { Button } from "@mui/material"
import IconLeftArrow from "src/assets/images/icon_left_arrow.svg";
import IconRemove from "src/assets/images/icon_remove.svg";


export const RemoveDepotManager = ({
    selectedRow,
    selectedDepotManagersRow,
    handleGoBackClick,
    handleRemoveAllocatedDepotManager
}) => {

    return <div>
        <div className="depot-form-header-style">
            <span className="allocate-mgnr-header-color me-2">
                REMOVE MANAGER
            </span>
            <span className="allocate-mgnr-subheader-color">
                {selectedRow.name}
            </span>
        </div>
        <div style={{ paddingLeft: 100, paddingRight: 100 }}>
            <div className="d-flex flex-column" style={{ marginTop: 100 }}>
                <span className="depotManagerName-style common-text-for-removeDepotManager">
                    {selectedDepotManagersRow.firstName}{" "}
                    {selectedDepotManagersRow.lastName}
                </span>
                <span className="removeDepotManager-text-removed common-text-for-removeDepotManager">
                    Will be removed from
                </span>
                <span className="removeDepotManager-text-depotName common-text-for-removeDepotManager mb-2">
                    {selectedRow.name}
                </span>
                <span className="removeDepotManager-text-acc-delete mb-2">
                    The personnel account will be de-activated
                </span>
                <span className="removeDepotManager-text-acc-delete">
                    This does not delete any data
                </span>
            </div>

            <div className="d-flex flex-column" style={{ marginTop: 100 }}>
                <span className="mb-3 confirm-msg-for-removeDepotManager">
                    Are you sure you want to proceed?
                </span>
                <div className="d-flex flex-row">
                    <Button
                        variant="outlined"
                        className="btn-bootstrap-submit-style"
                        startIcon={
                            <img
                                src={IconLeftArrow}
                                width={15}
                                height={15}
                                alt="new"
                            ></img>
                        }
                        onClick={handleGoBackClick}
                        type="submit"
                    >
                        No, Go Back
                    </Button>

                    <Button
                        variant="outlined"
                        className="btn-bootstrap-submit-style ms-3"
                        style={{ color: "red", borderColor: "red" }}
                        onClick={handleRemoveAllocatedDepotManager}
                        startIcon={
                            <img
                                src={IconRemove}
                                width={15}
                                height={15}
                                alt="new"
                            ></img>
                        }
                    >
                        Yes, Remove Manager
                    </Button>
                </div>
            </div>
        </div>
    </div>
}